import {Injectable} from '@angular/core';
import {Feature} from "@app/_models/api";
import {TableOptionsService} from "@app/_services/table-options.service";

@Injectable({
    providedIn: 'root'
})
export class FeatureFlagsAdminService extends TableOptionsService<Feature> {
    constructor() {
        super();
    }

    public override matches(element: Feature, term: string) {
        return (
            element.code?.toLowerCase().includes(term.toLowerCase()) ||
            element.description?.toLowerCase().includes(term.toLowerCase())
        );
    }
}